/*********************************************************************************************
* Initialize the sticky CTA behavior.
	* 
*/
function initializeStickyCTA() {
	const classicCTA = document.querySelector('[data-cta]');
	const stickyCTA = document.querySelector('[data-sticky-cta]');

	// Vérifie que les éléments existent
	if (!classicCTA || !stickyCTA) {
		console.error("Les éléments [data-cta] ou [data-sticky-cta] n'existent pas.");
		return;
	}

	// Crée un observateur pour surveiller la visibilité du CTA principal
	const observer = new IntersectionObserver((entries) => {
		entries.forEach(entry => {
			if (!entry.isIntersecting) {
				// Si le CTA principal n'est plus visible
				stickyCTA.classList.remove('mm-none');
				stickyCTA.classList.add('mm-flex');
			} else {
				// Si le CTA principal est visible
				stickyCTA.classList.add('mm-none');
				stickyCTA.classList.remove('mm-flex');
			}
		});
	}, {
		root: null, // viewport par défaut
		threshold: 0 // détecter si n'importe quelle partie de l'élément est visible
	});

	// Lancer l'observation du CTA principal
	observer.observe(classicCTA);
}

/*********************************************************************************************
* Initialize the Splide carousel for the reassurance slider.
	* 
*/
function mmSlideProductReassurance() {
	var splideElemMain = document.querySelector("#slider-reassurance");

	if (splideElemMain) {
		var main = new Splide(splideElemMain, {
			type: "slide",
			rewind: true,
			pagination: true,
			arrows: false,
			autoplay: true,
			interval: 5000,
			perPage: 1,
		});
		main.mount();
	}
}

/*********************************************************************************************
* Change the quantity value in the input field and update the related prices.
	*
	* @param {number} delta - The change to apply to the current quantity (e.g., +1 or -1).
	* @param {string} inputId - The ID of the input field where the quantity is adjusted.
*/
function mmChangeQtty(delta, inputId) {
	let input = document.getElementById(inputId);
	const plusBtn = document.querySelector(`[data-qtty-plus="${inputId}"]`);

	if (delta === -1 && input.value === "1") {
		return;
	} else {
		var newValue = parseInt(input.value, 10) + parseInt(delta, 10);

		// Vérification si la nouvelle valeur atteint ou dépasse le maximum autorisé
		if (input.max && newValue >= parseInt(input.max, 10)) {
			newValue = parseInt(input.max, 10); // Limiter à la valeur maximale
			plusBtn.setAttribute("disabled", "true"); // Désactiver le bouton "+"
		} else {
			plusBtn.removeAttribute("disabled"); // Réactiver le bouton "+" si on est en dessous de la limite
		}

		// Mise à jour de la valeur de l'input
		input.value = newValue;

		// Synchroniser tous les autres sélecteurs de quantité pour le même produit
		mmSyncQuantitySelectors(newValue, inputId);

		// Mise à jour des prix en fonction de la nouvelle quantité
		mmUpdatePrice(newValue);
	}
}

/*********************************************************************************************
* Format a price in cents, with the currency symbol first in English (€20.90) and last otherwise (20.90€).
	*
	* @param {number} cents - The price in cents.
	* @returns {string} The formatted price.
*/
function mmFormatPrice(cents) {
	var amount = (cents / 100).toFixed(2);
	return window.Shopify?.locale === "en" ? "€" + amount : amount + "€";
}

/*********************************************************************************************
* Update the displayed prices based on the new quantity.
	*
	* @param {number} qtty - The current product quantity used to calculate the prices.
*/
function mmUpdatePrice(qtty) {
	var priceAll = document.querySelectorAll("[data-price]");
	var comparePriceAll = document.querySelectorAll("[data-compare-price]");

	// Met à jour les prix normaux
	priceAll.forEach(function (price) {
		var priceValue = parseFloat(price.dataset.price);
		if (!isNaN(priceValue)) {
		// Vérifier si le prix doit être multiplié par la quantité
		var multiplyPriceAttr = price.getAttribute('data-multiply-price');
		var shouldMultiply = multiplyPriceAttr !== 'false';
		var finalPrice = shouldMultiply ? (priceValue * qtty) : priceValue;
			
			price.innerHTML = mmFormatPrice(finalPrice);
		} else {
			console.error("Valeur de prix non valide : ", price.dataset.price);
		}
	});

	// Met à jour les prix comparatifs
	comparePriceAll.forEach(function (comparePrice) {
		var comparePriceValue = parseFloat(comparePrice.dataset.comparePrice);
		if (!isNaN(comparePriceValue)) {
			// Vérifier si le prix comparatif doit être multiplié par la quantité
			var multiplyPriceAttr = comparePrice.getAttribute('data-multiply-price');
			var shouldMultiply = multiplyPriceAttr !== 'false';
			var finalPrice = shouldMultiply ? (comparePriceValue * qtty) : comparePriceValue;
			comparePrice.innerHTML = mmFormatPrice(finalPrice);
		} else {
			console.error("Valeur de prix comparatif non valide : ", comparePrice.dataset.comparePrice);
		}
	});
}

/*********************************************************************************************
* Synchronize all quantity selectors for the same product.
	*
	* @param {number} newValue - The new quantity value to sync.
	* @param {string} sourceInputId - The ID of the input that triggered the change.
*/
function mmSyncQuantitySelectors(newValue, sourceInputId) {
	// Extraire le produit ID et section ID de l'input source
	const sourceParts = sourceInputId.split('-');
	if (sourceParts.length < 3) return;
	
	const productId = sourceParts[1];
	const sectionId = sourceParts[2];
	
	// Trouver tous les inputs de quantité pour le même produit
	const allQuantityInputs = document.querySelectorAll(`input[id^="quantity-${productId}-${sectionId}"]`);
	
	allQuantityInputs.forEach(function(input) {
		if (input.id !== sourceInputId) {
			input.value = newValue;
		}
	});
}

/*********************************************************************************************
* Class for handling variant selection
	* 
*/
class VariantSelector extends HTMLElement {
	constructor() {
		super();
		this.cached = {};
		this.container = this.closest("#product-form");
		this.addEventListener("change", this.onVariantChange);
	}

	/*********************************************************************************************
	* Handle variant change event.
		* 
	*/
	onVariantChange() {
		this.getSelectedOptions();
		this.getSelectedVariant();

		if (this.currentVariant) {
			this.updateURL();
			if (this.dataset.imageVariant) {
                this.updateImagesVariant();
            } else {
                this.updateMedia();
            }
            this.variantFetch();
		}
	}

	/*********************************************************************************************
	* Get selected options from the variant checkboxes.
		*
	*/
	getSelectedOptions() {
		this.options = Array.from(this.querySelectorAll(".mm-product-variant-checkbox:checked"), (checkbox) => checkbox.value);
	}

	/*********************************************************************************************
	* Get variant data from the embedded JSON.
		*
		* @returns {Object} - The variant data.
	*/
	getVariantJSON() {
		this.variantData = JSON.parse(this.querySelector('[type="application/json"]').textContent);
		return this.variantData;
	}

	/*********************************************************************************************
	* Get the selected variant based on selected options.
		*
	*/
	getSelectedVariant() {
		this.currentVariant = this.getVariantJSON().find((variant) => {
			const findings = !variant.options
				.map((option, index) => {
					return this.options[index] === option;
				})
				.includes(false);

			if (findings) return variant;
		});
	}

	/*********************************************************************************************
	* Update the URL to include the selected variant ID.
		*
	*/
	updateURL() {
		window.history.replaceState({}, "", `${this.dataset.url}?variant=${this.currentVariant.id}`);
	}
	

	/*********************************************************************************************
	* Fetch variant data from the server and cache it.
		*
	*/
	variantFetch() {
		var variantUrl = `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`;

		if (this.cached[variantUrl]) {
			this.renderVariantInfo(this.cached[variantUrl]);
			return;
		}

		fetch(variantUrl)
			.then((response) => response.text())
			.then((responseText) => {
				const html = new DOMParser().parseFromString(responseText, "text/html");
				this.cached[variantUrl] = html;
				this.renderVariantInfo(html);
			})
			.catch((e) => {
				console.error(e);
			});
	}

	/*********************************************************************************************
	* Render variant information in the DOM.
		*
		* @param {Document} html - The HTML document containing the variant information.
	*/
	renderVariantInfo(html) {
		this.updateElementOuter("#product_id", html);
		this.updateElementOuter("#product_form_selected_variant_id", html);
		this.updateElementOuter(".mm-product-price", html);
		this.updateMultipleElement(".mm-product-form-variant-value", html);
		this.updateMultipleElement("[data-cta]", html);
		this.updateImagesVariant();
	}

	/*********************************************************************************************
	* Update the inner HTML of an element.
		*
		* @param {string} selector - The CSS selector of the element to update.
		* @param {HTMLElement} html - The HTML element containing the new content.
	*/
	updateElement(selector, html) {
		const destination = this.container.querySelector(selector);
		const source = html.querySelector(selector);
		if (source && destination) destination.innerHTML = source.innerHTML;
	}

	/*********************************************************************************************
	* Update the outer HTML of an element.
		*
		* @param {string} selector - The CSS selector of the element to update.
		* @param {HTMLElement} html - The HTML element containing the new content.
	*/
	updateElementOuter(selector, html) {
		const destination = this.container.querySelector(selector);
		const source = html.querySelector(selector);
		if (source && destination) destination.outerHTML = source.outerHTML;
	}

	/*********************************************************************************************
	* Update the outer HTML of multiple elements.
		*
		* @param {string} selector - The CSS selector of the element to update.
		* @param {HTMLElement} html - The HTML element containing the new content.
	*/
	updateMultipleElement(selector, html) {
        const destination = this.container.querySelectorAll(selector);
        const source = html.querySelectorAll(selector);

        if (source && destination) {
            for (let index = 0; index < source.length; index++) {
                destination[index].outerHTML = source[index].outerHTML;
            }
        }
    }

	/*********************************************************************************************
	* Update the media carousel to display the featured media of the current variant.
		*
	*/
	updateMedia() {
        if (this.currentVariant && this.currentVariant.featured_media) {
            var variant_media_id = this.currentVariant.featured_media.id;
            var allMainMedia = document.querySelectorAll(".mm-product-medias .splide__slide");

            allMainMedia.forEach((media, index) => {
                if (media.dataset.id != null && parseInt(media.dataset.id) == variant_media_id) {
                    splideMainInstance.go(index);
                }
            });
        }
    }

	/*********************************************************************************************
	* Update the visibility of the media sliders for the current variant.
		*
	*/
	updateImagesVariant() {
        var allMainMedia = document.querySelectorAll(".main-slider-variant");
        allMainMedia.forEach((media) => {
            if (media.dataset.variantid == this.currentVariant.id) {
                media.style.display = "flex";
            } else {
                media.style.display = "none";
            }
        });
        var allThumbnailMedia = document.querySelectorAll(".thumbnail-slider-variant");
        allThumbnailMedia.forEach((media) => {
            if (media.dataset.variantid == this.currentVariant.id) {
                media.style.display = "flex";
            } else {
                media.style.display = "none";
            }
        });
    }
}

/*********************************************************************************************
* Define the custom element
	*
*/
customElements.define("variant-selector", VariantSelector);


/*********************************************************************************************
* Loaded Listenner
	*
*/
document.addEventListener("DOMContentLoaded", () => {
	mmSlideProductReassurance();
	initializeStickyCTA();
});
